<template>
    <span class="material-icons" v-if="type === ActivityTypes.USER_STATUS_CHANGED.id"> local_cafe </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.BLOCK_VISITOR.id"> lock </span>
    <span class="material-icons text-success" v-else-if="type === ActivityTypes.UNBLOCK_VISITOR.id"> lock_open </span>
    <span class="material-icons text-success" v-else-if="type === ActivityTypes.VISITOR_TAG_ADDED.id"> local_offer </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.VISITOR_TAG_REMOVED.id"> local_offer </span>
    <span class="material-icons" v-else-if="type === ActivityTypes.USER_ADDED.id"> person_add </span>
    <span class="material-icons" v-else-if="type === ActivityTypes.CHANNEL_CREATED.id"> add_box </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.CHANNEL_REMOVED.id">
        remove_circle
    </span>
    <span class="material-icons" v-else-if="type === ActivityTypes.CHAT_OPENED.id"> chat </span>
    <span class="material-icons" v-else-if="type === ActivityTypes.CHAT_CLOSED.id"> mark_chat_read </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WEBHOOK_ADDED.id"> webhook </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.WEBHOOK_REMOVED.id">
        remove_circle
    </span>
    <span class="material-icons text-warning md-icon" v-else-if="type === ActivityTypes.WEBHOOK_UPDATED.id"> webhook </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TRIGGER_ADDED.id"> add_circle </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.TRIGGER_REMOVED.id">
        remove_circle
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TRIGGER_UPDATED.id"> update </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.DEPARTMENT_ADDED.id"> add_circle </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.DEPARTMENT_REMOVED.id">
        remove_circle
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.ROLE_ADDED.id"> add_circle </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.ROLE_REMOVED.id"> remove_circle </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TAGS_ADDED.id"> add_circle </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.TAGS_REMOVED.id"> remove_circle </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WELCOME_MESSAGE_ADDED.id"> add_circle </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.WELCOME_MESSAGE_REMOVED.id">
        remove_circle
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.BANNED_WORD_ADDED.id"> add_circle </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.BANNED_WORD_REMOVED.id">
        remove_circle
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TASK_WORKFLOW_CREATED.id"> add_circle </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TASK_UPDATE_PRIORITY.id">arrow_upload_ready</span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TASK_ADDED_TAGS.id"> style </span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.TASK_REMOVED_TAGS.id"> style </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TASK_UPDATE_TITLE.id"> edit </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TASK_UPDATE_DESCRIPTION.id"> description </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TASK_UPDATE_START_DATE.id"> event </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TASK_UPDATE_END_DATE.id"> event </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TASK_UPDATE_OWNER.id"> person </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TASK_ADDED_FOLLOWERS.id"> group_add </span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.TASK_REMOVED_FOLLOWERS.id"> group_remove </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TASK_ADDED_COLLABORATORS.id"> group_add </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TASK_UPDATE_CHECKLIST.id"> checklist </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TASK_ADDED_SUBTASK.id"> add_task </span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.TASK_REMOVED_SUBTASK.id"> remove_circle </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TASK_ADDED_ATTACHMENT.id"> attach_file </span>
    <span class="material-icons md-icon" v-else-if="type===ActivityTypes.TASK_COMPLETED.id"> done </span>
    <span class="material-icons md-icon" v-else-if="type===ActivityTypes.TASK_ARCHIVED.id"> archive </span>
    <span class="material-icons md-icon text-success" v-else-if="type===ActivityTypes.TASK_RESTORED.id"> restore </span>
    <span class="material-icons md-icon text-success" v-else-if="type===ActivityTypes.TASK_UNARCHIVED.id"> unarchive </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.SETTINGS_UPDATED.id"> settings </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.MAIL_ADDRESS_ADDED.id"> add_circle </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.USER_ADDED_TO_DEPARTMENT.id"> update </span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.USER_REMOVED_FROM_DEPARTMENT.id">
        remove_circle
    </span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.TASK_DELETED.id">
        remove_circle
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.CHANNEL_VISIBILITY_CHANGED.id">
        update
    </span>
    <span class="material-icons text-warning md-icon" v-else-if="type === ActivityTypes.CHANNEL_FORWARD_CONFIG_UPDATED.id">
        forward
    </span>
    <span class="material-icons text-info md-icon" v-else-if="type === ActivityTypes.CHANNEL_ZOHO_CONFIG_UPDATED.id">
        sync_alt
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.CONTENT_ADDED.id"> add_circle </span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.CONTENT_REMOVED.id">
        remove_circle
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.CUSTOMER_GROUP_ADDED.id"> add_circle </span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.CUSTOMER_GROUP_REMOVED.id">
        remove_circle
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.CUSTOMER_GROUP_UPDATED.id"> update </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.CHAT_ASSIGNED_TO_USER.id"> maps_ugc </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.CHAT_FORWARDED_TO_USER.id">
        phone_forwarded
    </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.USER_JOINED_TO_CHAT.id"> shortcut </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.USER_LOGGED_IN.id"> login </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.TICKET_ASSIGNED_TO_USER.id">
        assignment_ind
    </span>

    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.WHATSAPP_BROADCAST_CREATED.id">
        cell_tower
    </span>
    <span class="material-icons text-warning" v-else-if="type === ActivityTypes.WHATSAPP_BROADCAST_CANCELED.id">
        cell_tower
    </span>
    <span class="material-icons text-success" v-else-if="type === ActivityTypes.WHATSAPP_BROADCAST_COMPLETED.id">
        cell_tower
    </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.WHATSAPP_BROADCAST_FAILED.id">
        cell_tower
    </span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.TASK_WORKFLOW_DELETED.id">
        remove_circle
    </span>
    <span class="material-icons text-success md-icon" v-else-if="type === ActivityTypes.TASK_WORKFLOW_RESTORED.id">
        restore
    </span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.TASK_WORKFLOW_PERMANENTLY_DELETED.id">
        delete_forever
    </span>
    <span class="metarial-icons md-icon" v-else-if="type === ActivityTypes.BILLING_ADDRESS_UPDATED.id"> update </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.INVOICE_CREATED.id"> cell_tower </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.PLAN_STARTED.id"> cell_tower </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.PLAN_CANCELED.id"> cell_tower </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.INVOICE_PAYMENT_RECEIVED.id"> paid </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.INVOICE_PAYMENT_FAILED.id">
        money_off_csred
    </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.AUTO_REBALANCE_SUCCESS.id"> money_off_csred </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.AUTO_REBALANCE_FAILED.id"> money_off_csred </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.AUTO_REBALANCE_DISABLED.id"> money_off_csred </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.PAYMENT_METHOD_ADDED.id"> add_card </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.INVOICE_REFUNDED.id">
        assignment_return
    </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.LOGIN_FORM_ACTIVATED.id">
        format_indent_decrease
    </span>
    <span class="material-icons text-dark" v-else-if="type === ActivityTypes.LOGIN_FORM_DEACTIVATED.id">
        format_indent_increase
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.LOGIN_FORM_UPDATED.id"> update </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.USER_REMOVED.id"> remove_circle </span>
    <span class="material-icons md-icon text-dark" v-else-if="type === ActivityTypes.CONTACT_PROP_ADDED.id">
        add_circle
    </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.CONTACT_PROP_REMOVED.id">
        remove_circle
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TASK_CREATED.id"> add_circle </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TASK_STAGE_CHANGED.id"> update </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WHATSAPP_CREDIT_LOW.id"> expand_more </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.CHATBOT_CREATED.id"> smart_toy </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.CHATBOT_CREDIT_LOW.id"> report </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.CHATBOT_CREDIT_DONE.id"> disc_full </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.SYSTEM_STATUS.id"> update </span>
    <span class="material-icons text-danger" v-else-if="type === ActivityTypes.CHATBOT_DELETED.id">
        remove_circle
    </span>
    <span class="material-icons text-success md-icon" v-else-if="type === ActivityTypes.CHATBOT_RESTORED.id">restore</span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.CHATBOT_PUBLISHED.id"> public </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.TASK_ASSIGNED_TO_USER.id"> add_task </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WHATSAPP_V1_BOT_STATE_CHANGED.id">
        qr_code_scanner
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WHATSAPP_V2_BOT_STATE_CHANGED.id">
        qr_code_scanner
    </span>
    <span
        class="material-icons md-icon"
        v-else-if="type === ActivityTypes.WABA_SUPSIS_PARTNER_REMOVE.id || type === ActivityTypes.WABA_SUPSIS_PARTNER_REMOVE_LEGACY.id"
    >
        link_off
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WABA_SUPSIS_PARTNER_ADDED.id">
        person_add
    </span>
    <span
        class="material-icons md-icon"
        v-else-if="type === ActivityTypes.WABA_SUPSIS_ACCOUNT_DELETED.id || type === ActivityTypes.WABA_SUPSIS_ACCOUNT_DELETED_LEGACY.id"
    >
        delete_forever
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WABA_SUPSIS_ACCOUNT_VIOLATION.id">
        warning
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WABA_SUPSIS_AD_ACCOUNT_LINKED.id">
        link
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WABA_SUPSIS_AUTH_INTL_PRICE_ELIGIBILITY_UPDATE.id">
        price_change
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WABA_SUPSIS_DISABLED_UPDATE.id">
        block
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WABA_SUPSIS_MM_LITE_TERMS_SIGNED.id">
        fact_check
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WABA_SUPSIS_PARTNER_APP_INSTALLED.id">
        install_mobile
    </span>
    <span class="material-icons md-icon text-danger" v-else-if="type === ActivityTypes.WABA_SUPSIS_PARTNER_APP_UNINSTALLED.id">
        delete_forever
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WABA_SUPSIS_PARTNER_CLIENT_CERTIFICATION_STATUS_UPDATE.id">
        verified_user
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WABA_SUPSIS_BUSINESS_PRIMARY_LOCATION_COUNTRY_UPDATE.id">
        public
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WABA_SUPSIS_VOLUME_BASED_PRICING_TIER_UPDATE.id">
        trending_up
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WABA_SUPSIS_MESSAGE_TEMPLATE_COMPONENTS_UPDATE.id">
        article
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WABA_SUPSIS_MESSAGE_TEMPLATE_STATUS_UPDATE.id">
        speed
    </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.WABA_SUPSIS_TEMPLATE_CATEGORY_UPDATE.id">
        category
    </span>
    <span class="metarial-icons md-icon" v-else-if="type === ActivityTypes.RESERVATION_CREATED_PLAN.id"> today </span>
    <span class="metarial-icons md-icon" v-else-if="type === ActivityTypes.RESERVATION_UPDATED_PLAN.id">
        event_repeat
    </span>
    <span class="metarial-icons md-icon" v-else-if="type === ActivityTypes.RESERVATION_DELETED_PLAN.id">
        event_busy
    </span>
    <span class="metarial-icons md-icon" v-else-if="type === ActivityTypes.RESERVATION_CREATED.id"> today </span>
    <span class="metarial-icons md-icon" v-else-if="type === ActivityTypes.RESERVATION_UPDATED.id"> event_repeat </span>
    <span class="metarial-icons md-icon" v-else-if="type === ActivityTypes.RESERVATION_DELETED.id"> event_busy </span>
    <span class="metarial-icons md-icon" v-else-if="type === ActivityTypes.CONTACT_OWNER_UPDATED.id"> update </span>
    <span class="metarial-icons md-icon" v-else-if="type === ActivityTypes.WHITE_LIST_ADDED.id"> update </span>
    <span class="metarial-icons md-icon" v-else-if="type === ActivityTypes.WHITE_LIST_REMOVED.id"> update </span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.AUTOMATION_CREATED.id">rocket_launch</span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.AUTOMATION_DELETED.id">delete</span>
    <span class="material-icons text-success md-icon" v-else-if="type === ActivityTypes.AUTOMATION_RESTORED.id">restore</span>
    <span class="material-icons text-success md-icon" v-else-if="type === ActivityTypes.AUTOMATION_PUBLISHED.id">publish</span>
    <span class="material-icons text-warning md-icon" v-else-if="type === ActivityTypes.AUTOMATION_UNPUBLISHED.id">unpublished</span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.AUTOMATION_UPDATED.id">edit</span>
    <span class="material-icons text-success md-icon" v-else-if="type === ActivityTypes.FORM_CREATED.id">add_box</span>
    <span class="material-icons md-icon" v-else-if="type === ActivityTypes.FORM_UPDATED.id">edit</span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.FORM_DELETED.id">delete</span>
    <span class="material-icons text-success md-icon" v-else-if="type === ActivityTypes.FORM_RESTORED.id">restore</span>
    <span class="material-icons text-info md-icon" v-else-if="type === ActivityTypes.FORM_DOWNLOADED.id">download</span>
    <span class="material-icons text-warning md-icon" v-else-if="type === ActivityTypes.USER_ROLE_CHANGED.id">admin_panel_settings</span>
    <span class="material-icons text-primary md-icon" v-else-if="type === ActivityTypes.USER_PASSWORD_CHANGED.id">lock_reset</span>
    <span class="material-icons text-info md-icon" v-else-if="type === ActivityTypes.USER_EMAIL_CHANGED.id">email</span>
    <span class="material-icons text-success md-icon" v-else-if="type === ActivityTypes.USER_NAME_CHANGED.id">badge</span>
    <span class="material-icons text-secondary md-icon" v-else-if="type === ActivityTypes.USER_PHONE_CHANGED.id">phone</span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.USER_DISABLED.id">block</span>
    <span class="material-icons text-purple md-icon" v-else-if="type === ActivityTypes.ROLE_UPDATED.id">manage_accounts</span>
    <span class="material-icons text-teal md-icon" v-else-if="type === ActivityTypes.TASK_WORKFLOW_UPDATED.id">account_tree</span>
    <span class="material-icons text-green md-icon" v-else-if="type === ActivityTypes.TASK_WORKFLOW_PIPELINE_STAGE_ADDED.id">add_box</span>
    <span class="material-icons text-blue md-icon" v-else-if="type === ActivityTypes.TASK_WORKFLOW_PIPELINE_STAGE_UPDATED.id">edit</span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.TASK_WORKFLOW_PIPELINE_STAGE_DELETED.id">delete</span>
    <span class="material-icons text-warning md-icon" v-else-if="type === ActivityTypes.DRIVE_FOLDER_CREATED.id">create_new_folder</span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.DRIVE_FOLDER_DELETED.id">folder_delete</span>
    <span class="material-icons text-blue md-icon" v-else-if="type === ActivityTypes.DRIVE_FOLDER_RENAMED.id">drive_file_rename_outline</span>
    <span class="material-icons text-success md-icon" v-else-if="type === ActivityTypes.DRIVE_FILE_ADDED.id">note_add</span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.DRIVE_FILE_DELETED.id">delete_outline</span>
    <span class="material-icons text-success md-icon" v-else-if="type === ActivityTypes.TASK_MODULE_RULES_ENABLED.id">rule</span>
    <span class="material-icons text-warning md-icon" v-else-if="type === ActivityTypes.TASK_MODULE_RULES_DISABLED.id">rule</span>
    <span class="material-icons text-primary md-icon" v-else-if="type === ActivityTypes.TASK_MODULE_RULES_RULE_ADDED.id">add_circle</span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.TASK_MODULE_RULES_RULE_DELETED.id">delete</span>
    <span class="material-icons text-info md-icon" v-else-if="type === ActivityTypes.TASK_MODULE_RULES_RULE_UPDATED.id">edit</span>
    <span class="material-icons text-success md-icon" v-else-if="type === ActivityTypes.TASK_MODULE_RULES_RULE_ENABLED.id">check_circle</span>
    <span class="material-icons text-warning md-icon" v-else-if="type === ActivityTypes.TASK_MODULE_RULES_RULE_DISABLED.id">cancel</span>
    <span class="material-icons text-success md-icon" v-else-if="type === ActivityTypes.CONTACT_MODULE_RULES_ENABLED.id">check_circle</span>
    <span class="material-icons text-warning md-icon" v-else-if="type === ActivityTypes.CONTACT_MODULE_RULES_DISABLED.id">cancel</span>
    <span class="material-icons text-info md-icon" v-else-if="type === ActivityTypes.CONTACT_MODULE_RULES_RULE_ADDED.id">add_circle</span>
    <span class="material-icons text-warning md-icon" v-else-if="type === ActivityTypes.CONTACT_MODULE_RULES_RULE_UPDATED.id">edit</span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.CONTACT_MODULE_RULES_RULE_DELETED.id">delete</span>
    <span class="material-icons text-success md-icon" v-else-if="type === ActivityTypes.CONTACT_MODULE_RULES_RULE_ENABLED.id">check_circle</span>
    <span class="material-icons text-warning md-icon" v-else-if="type === ActivityTypes.CONTACT_MODULE_RULES_RULE_DISABLED.id">cancel</span>
    <span class="material-icons text-info md-icon" v-else-if="type === ActivityTypes.DEVELOPER_TOKEN_CHANGED.id">vpn_key</span>
    <span class="material-icons text-success md-icon" v-else-if="type === ActivityTypes.TABLE_CREATED.id">table_chart</span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.TABLE_DELETED.id">delete</span>
    <span class="material-icons text-success md-icon" v-else-if="type === ActivityTypes.TABLE_RESTORED.id">restore</span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.TABLE_PERMANENTLY_DELETED.id">delete_forever</span>
    <span class="material-icons text-info md-icon" v-else-if="type === ActivityTypes.TABLE_FIELD_ADDED.id">add_box</span>
    <span class="material-icons text-warning md-icon" v-else-if="type === ActivityTypes.TABLE_FIELD_UPDATED.id">edit</span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.TABLE_FIELD_DELETED.id">delete</span>
    <span class="material-icons text-info md-icon" v-else-if="type === ActivityTypes.TABLE_VIEW_ADDED.id">visibility</span>
    <span class="material-icons text-warning md-icon" v-else-if="type === ActivityTypes.TABLE_VIEW_UPDATED.id">edit</span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.TABLE_VIEW_DELETED.id">delete</span>
    <span class="material-icons text-info md-icon" v-else-if="type === ActivityTypes.TABLE_PAGE_ADDED.id">note_add</span>
    <span class="material-icons text-warning md-icon" v-else-if="type === ActivityTypes.TABLE_PAGE_UPDATED.id">edit</span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.TABLE_PAGE_DELETED.id">delete</span>
    <span class="material-icons text-info md-icon" v-else-if="type === ActivityTypes.TABLE_WIDGET_ADDED.id">widgets</span>
    <span class="material-icons text-warning md-icon" v-else-if="type === ActivityTypes.TABLE_WIDGET_UPDATED.id">edit</span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.TABLE_WIDGET_DELETED.id">delete</span>
    <span class="material-icons text-warning md-icon" v-else-if="type === ActivityTypes.TABLE_PERMISSION_CHANGED.id">lock</span>
    <span class="material-icons text-info md-icon" v-else-if="type === ActivityTypes.TABLE_DATA_DOWNLOADED.id">download</span>
    <span class="material-icons text-info md-icon" v-else-if="type === ActivityTypes.TABLE_DATA_IMPORTED.id">cloud_upload</span>
    <span class="material-icons text-warning md-icon" v-else-if="type === ActivityTypes.TABLE_DATA_BATCH_UPDATED.id">update</span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.TABLE_DATA_BATCH_DELETED.id">delete_sweep</span>
    <span class="material-icons text-success md-icon" v-else-if="type === ActivityTypes.CONTACT_BATCH_UPDATED.id">group</span>
    <span class="material-icons text-info md-icon" v-else-if="type === ActivityTypes.CHAT_DATA_DOWNLOADED.id">download</span>
    <span class="material-icons text-info md-icon" v-else-if="type === ActivityTypes.WEB_APP_CREATED.id">web</span>
    <span class="material-icons text-warning md-icon" v-else-if="type === ActivityTypes.WEB_APP_UPDATED.id">edit</span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.WEB_APP_DELETED.id">delete</span>
    <span class="material-icons text-success md-icon" v-else-if="type === ActivityTypes.WEB_TAB_CREATED.id">tab</span>
    <span class="material-icons text-warning md-icon" v-else-if="type === ActivityTypes.WEB_TAB_UPDATED.id">edit</span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.WEB_TAB_DELETED.id">delete</span>
    <span class="material-icons text-success md-icon" v-else-if="type === ActivityTypes.MODULE_CREATED.id">add_box</span>
    <span class="material-icons text-warning md-icon" v-else-if="type === ActivityTypes.MODULE_UPDATED.id">edit</span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.MODULE_DELETED.id">delete</span>
    <span class="material-icons text-success md-icon" v-else-if="type === ActivityTypes.RELATION_CREATED.id">link</span>
    <span class="material-icons text-warning md-icon" v-else-if="type === ActivityTypes.RELATION_UPDATED.id">edit</span>
    <span class="material-icons text-success md-icon" v-else-if="type === ActivityTypes.VOICE_AGENT_CREATED.id">record_voice_over</span>
    <span class="material-icons text-warning md-icon" v-else-if="type === ActivityTypes.VOICE_AGENT_UPDATED.id">record_voice_over</span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.VOICE_AGENT_DELETED.id">record_voice_over</span>
    <span class="material-icons text-info md-icon" v-else-if="type === ActivityTypes.VOICE_AGENT_PHONE_NUMBER_INBOUND_AGENT_CHANGED.id">phone</span>
    <span class="material-icons text-info md-icon" v-else-if="type === ActivityTypes.VOICE_AGENT_PHONE_NUMBER_OUTBOUND_AGENT_CHANGED.id">phone</span>
    <span class="material-icons text-success md-icon" v-else-if="type === ActivityTypes.VOICE_AGENT_BATCH_CALL_CREATED.id">call</span>
    <span class="material-icons text-success md-icon" v-else-if="type === ActivityTypes.VOICE_AGENT_KNOWLEDGE_BASE_CREATED.id">library_books</span>
    <span class="material-icons text-danger md-icon" v-else-if="type === ActivityTypes.VOICE_AGENT_KNOWLEDGE_BASE_DELETED.id">library_books</span>
    <span class="metarial-icons md-icon" v-else-if="type === ActivityTypes.CUSTOM.id"> message </span>
</template>
<script>
import Vue from "vue";
import ActivityTypes from "../ActivityTypes";

export default Vue.extend({
    name: "ActivityIconViewer",
    props: {
        type: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            ActivityTypes,
        };
    },
});
</script>

<style scoped lang="scss">
.material-icons {
    font-size: 20px;
    font-weight: 600;
}
</style>
